import React, { forwardRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsTreeMap from 'highcharts/modules/treemap';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsBoost from 'highcharts/modules/boost';
import { RefObjectForHighchartsReact } from './Chart.types';

HighchartsMore(Highcharts);
HighchartsTreeMap(Highcharts);
HighchartsBoost(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsAccessibility(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    thousandsSep: ',',
  },
});

export const Chart = forwardRef<RefObjectForHighchartsReact, HighchartsReact.Props>(
  (props, ref) => (
    <HighchartsReact
      ref={ref}
      highcharts={Highcharts}
      {...props}
      containerProps={{
        ...(props.containerProps || {}),
        style: {
          height: '100%',
          ...(props.containerProps?.style || {}),
        },
      }}
    />
  ),
);
